<script>

    import { toast } from 'bulma-toast'
    import { tilPricingsStore, modalStore } from '../stores'

    import TilService from '../$services/til.service'

    import Form from '../$components/form.svelte'
    import Save from '../$components/button.save.svelte'
    import Cancel from '../$components/button.cancel.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import Select from '../$components/select.svelte'
    import SelectOwners from '../$components/select.owners.svelte'
    import { ZONE_OPTIONS } from './zones'

    const serviceOptions = [
        { value: 'Express', text: 'Express' },
        { value: 'Metro Express', text: 'Metro Express' },
    ]

    let loading = false
    let data = {
        ownerId: '60edc374e9091e00151699c0',
        service: '',
        volumetricMin: 0,
        volumetricMax: null,
        pickupZoneOperative: "",
        deliveryZoneOperative: "",
        pickupIATA: null,
        deliveryIATA: null,
        price: null,
    }

    async function createTilPricing() {

        loading = true
        const resp = await TilService.createTilPricing(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        tilPricingsStore.append(resp.data)
        modalStore.close()
    }

</script>

<Form on:submit={createTilPricing} {loading} >

    <div class="columns">
        <div class="column">
            <SelectOwners bind:ownerId={data.ownerId} label="Propietario" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <Select bind:value={data.service} label="Servicio" text="Servicio" options={serviceOptions} />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.volumetricMin} label="Peso mínimo" placeholder="Peso mínimo" min="0" step="0.1" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.volumetricMax} label="Peso máximo" placeholder="Peso máximo" min="0" step="0.1" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <Select bind:value={data.pickupZoneOperative} label="Zona origen" text="Zona origen" options={ZONE_OPTIONS} />
        </div>
        <div class="column">
            <Select bind:value={data.deliveryZoneOperative} label="Zona destino" text="Zona destino" options={ZONE_OPTIONS} />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.pickupIATA} label="IATA origen" placeholder="IATA origen" required={false} />
        </div>
        <div class="column">
            <InputText bind:value={data.deliveryIATA} label="IATA destino" placeholder="IATA destino" required={false} />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.price} label="Precio" placeholder="Precio" step="0.01" />
        </div>
    </div>

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <div class="buttons">
            <Cancel on:click={modalStore.close} />
            <Save />
        </div>
    </div>

</Form>
